<template>
    <div class="switch-single">
        <!-- <span :id="id"> <slot></slot> </span> -->
        <button
                role="switch"
                :aria-checked="isChecked.toString()"
                :aria-labelledby="id"
                v-on:click.stop.prevent="toggle"
        >
          <span v-for="(option, key) in reverseOptions" :key="key">
              {{ option }}
          </span>
        </button>
    </div>
</template>

<script>
    export default {
        name: "SwitchButton",
        data: function() {
            return {
                id: null,
                isChecked: this.value
            };
        },
        props: {
            value: {
                type: Boolean,
                default: false
            },
            options: {
            required: true
            },
        },
        computed: {
            reverseOptions() {
                return this.options.slice().reverse();
          }     
        },
        methods: {
            toggle() {
                this.$emit("input", !this.isChecked);
                this.isChecked = !this.isChecked;
            }
        },
        mounted() {
            this.$emit("input", this.isChecked);
            this.id = Math.random()
                .toString(36)
                .substring(2, 15);
        }
    };
</script>

<style scoped>
    button {
        padding: 0.7rem;
        border: 2px solid #444444;
        border-radius: 0.25rem;
        font: inherit;
        cursor: pointer;
        box-shadow: 0px 1px 3px #76b4bf;
        color: #444444;
        background: none;
    }

    [aria-checked] span {
        font-size: 0.9rem;
        font-weight: bold;
        display: inline-block;
        border-radius: 0.25rem;
        padding: 0.8rem;
        width: 38px;
        box-sizing: content-box;
    }

    [aria-checked="true"] :first-child,
    [aria-checked="false"] :last-child {
        border: 2px solid transparent;
        color: #fff;
    }

    [aria-checked="true"] :first-child {
      background-color: #2c3e50;
    }
    [aria-checked="false"] :last-child {
      background-color: #607d8b40;
      color: #444444;
    }

    @media (max-width: 767px) {

        button {
            padding: 0.4rem;
        }
        [aria-checked] span {
            padding: 5px 5px;
            box-sizing: border-box;
        }
    }
</style>